/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between 10 and 20: (|10 − 20| ÷ 15) × 100 ≈ 66.67%.`)
};

const es_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 10 y 20: (|10 − 20| ÷ 15) × 100 ≈ 66,67%.`)
};

const de_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen 10 und 20: (|10 − 20| ÷ 15) × 100 ≈ 66,67 %.`)
};

const nl_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tussen 10 en 20: (|10 − 20| ÷ 15) × 100 ≈ 66,67%.`)
};

const fr_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 10 et 20 : (|10 − 20| ÷ 15) × 100 ≈ 66,67 %.`)
};

const it_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra 10 e 20: (|10 − 20| ÷ 15) × 100 ≈ 66.67%.`)
};

const pt_br2_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 10 e 20: (|10 − 20| ÷ 15) × 100 ≈ 66,67%.`)
};

const pt_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 10 e 20: (|10 − 20| ÷ 15) × 100 ≈ 66.67%.`)
};

const ja_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10と20の間: (|10 − 20| ÷ 15) × 100 ≈ 66.67%。`)
};

const zh_pct_difference_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 和 20 之间：(|10 − 20| ÷ 15) × 100 ≈ 66.67%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_ex1", locale)
	if (locale === "en") return en_pct_difference_ex1(inputs)
	if (locale === "es") return es_pct_difference_ex1(inputs)
	if (locale === "de") return de_pct_difference_ex1(inputs)
	if (locale === "nl") return nl_pct_difference_ex1(inputs)
	if (locale === "fr") return fr_pct_difference_ex1(inputs)
	if (locale === "it") return it_pct_difference_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_ex1(inputs)
	if (locale === "pt") return pt_pct_difference_ex1(inputs)
	if (locale === "ja") return ja_pct_difference_ex1(inputs)
	return zh_pct_difference_ex1(inputs)
};